module.exports = __webpack_public_path__ + "static/tell-us-e7654067c327ced97985c67f569e0582.jpg";